import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomNotificationsService } from '../../../common/services/custom-notifications.service';

@Component({
    selector: 'app-subscription-plan-change-dialog',
    templateUrl: './subscription-plan-change-dialog.component.html',
    styleUrl: './subscription-plan-change-dialog.component.scss',
    standalone: false
})
export class SubscriptionPlanChangeDialogComponent implements OnInit {
  @Input() dialogDetails: any;

  returnValue: any = { isSuccess: false };

  constructor(
    public activeModal: NgbActiveModal,
    private notifyServ: CustomNotificationsService,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {
    console.log("dialogDetails : ", this.dialogDetails)
  }

  public accept(): void {
    this.returnValue.isSuccess = true;
    this.activeModal.close(this.returnValue);
  }

  public dismiss(): void {
    this.activeModal.dismiss();
  }
}
